export const TEST_ID = 'emptyState';
